import { render, staticRenderFns } from "./Bundles.vue?vue&type=template&id=d98c73fc&scoped=true&"
import script from "./Bundles.vue?vue&type=script&lang=ts&"
export * from "./Bundles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98c73fc",
  null
  
)

export default component.exports